import { Trans, useTranslation } from 'react-i18next';
import { Button, SquareButton } from '@app/core';
import { SelectionFooter } from 'components';

interface Props {
  selectedRowIds: string[];
  onDelete?: () => any;
  onInvite?: () => any;
  takeSpace?: boolean;
}

export const SelectionParticipantFooter = ({
  selectedRowIds,
  onDelete,
  onInvite,
  takeSpace,
}: Props) => {
  const { t } = useTranslation();
  const selectedCount = selectedRowIds.length || 0;
  return (
    <SelectionFooter
      text={t('participants.list.selectionFooter.nbSelected', {
        count: selectedCount,
      })}
      selectedCount={selectedCount}
      takeSpace={takeSpace}
    >
      <SquareButton
        color="red"
        variant="muted"
        icon="ri-delete-bin-line"
        onClick={onDelete}
      />
      <Button color="green" small onClick={onInvite}>
        <Trans i18nKey="participants.list.selectionFooter.invite" />
      </Button>
    </SelectionFooter>
  );
};
